import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login/Login.vue";
import Register from "../views/Register/Register.vue";
import Amend from "../views/Register/Amend.vue"
import ForgotPassword from "../views/ForgotPassword/ForgotPassword.vue";
import PasswordReset from "../views/PasswordReset/PasswordReset.vue";
import EmailVerification from "../views/EmailVerification/EmailVerification.vue";
import Payment from "../views/Payment/Payment.vue";
import Subscription from "../views/Subscription/Subscription.vue";
import FoodDiary from "../views/FoodDiary/FoodDiary.vue";
import FoodDiaryHistory from "../views/FoodDiary/History/History";
import FoodDiaryLanding from "../views/FoodDiary/Landing/Landing.vue";
import FoodDiarySearch from "../views/FoodDiary/Search/Search.vue";
import FoodDiarySearchResults from "../views/FoodDiary/SearchResults/SearchResults.vue";
import FoodDiaryAdd from "../views/FoodDiary/Add/Add.vue";
import FoodDiaryEdit from "../views/FoodDiary/Edit/Edit.vue";
import FoodDiaryMyMeals from "../views/FoodDiary/MyMeals/MyMeals.vue"


import Dashboard from "../views/Dashboard/Dashboard.vue";
import Lesson from "../views/Lesson/Lesson.vue";
import LessonBonus from "../views/LessonBonus/LessonBonus.vue";

import GettingStartedLayout from "../views/GettingStarted/Layout.vue";
import GettingStartedAboutYourself from "../views/GettingStarted/AboutYourself.vue";
import GettingStartedYourHealth from "../views/GettingStarted/YourHealth.vue";

import GettingStartedLocation from "../views/GettingStarted/Location.vue";
import GettingStartedGoals from "../views/GettingStarted/Goals.vue";
import GettingStartedPersonalise from "../views/GettingStarted/Personalise.vue";

import Profile from "../views/Profile/Profile.vue";
import ProfileFollowers from "../views/Profile/ProfileFollowers.vue";

import ProfileFollowing from "../views/Profile/ProfileFollowing.vue";
import ProfileProgress from "../views/Profile/ProfileProgress.vue";
import ProfileDiscussion from "../views/Profile/ProfileDiscussion.vue";
import ProfileGallery from "../views/Profile/ProfileGallery.vue";
import ProfileFoodDiary from "../views/Profile/ProfileFood.vue";

import QuestionsIndex from "../views/Questions/QuestionsIndex.vue";
import QuestionCreate from "../views/Questions/QuestionCreate.vue";
import QuestionThread from "../views/Questions/QuestionThread.vue";

import AnswerReport from "../views/Reports/AnswerReport.vue";
import QuestionReport from "../views/Reports/QuestionReport.vue";
import LifeReplyReport from "../views/Reports/LifeReplyReport.vue";
import LifeSubReplyReport from "../views/Reports/LifeSubReplyReport.vue";

import CheckinLayout from "../views/CheckIn/Layout.vue"

import Progress from "../views/AddProgress/AddProgress.vue";
import BloodGlucose from "../views/Tracking/BloodGlucose.vue";
import HbA1c from "../views/Tracking/HbA1c.vue";
import Weight from "../views/Tracking/Weight.vue";
import Sleep from "../views/Tracking/Sleep.vue";
import SleepWearable from "../views/Tracking/SleepWearable"
import SleepDeviceHistory from '../views/Tracking/SleepDeviceHistory'

import BloodPressure from "../views/Tracking/BloodPressure.vue";
import Ketones from "../views/Tracking/Ketones.vue";
import Insulin from "../views/Tracking/Insulin.vue";
import Medication from "../views/Tracking/Medication.vue";
import Mood from "../views/Tracking/Mood.vue";
import Cholesterol from "../views/Tracking/Cholesterol.vue";
import Activity from "../views/Tracking/Activity.vue"
import ActivityFitbit from "../views/Tracking/ActivityFitbit"

import WeightCheckin from "../views/CheckIn/Weight.vue"
import Hba1cCheckin from "../views/CheckIn/Hba1c.vue"
import GoalsCheckin from "../views/CheckIn/Goals.vue"

import Settings from "../views/Settings/Layout.vue";

import SettingsGeneral from "../views/Settings/General.vue";
import SettingsPrivacy from "../views/Settings/Privacy.vue";
import SettingsSecurity from "../views/Settings/Security.vue";
import SettingsNotifications from "../views/Settings/Notifications.vue";
import SettingsUnits from "../views/Settings/Units.vue";
import SettingsSubscription from '../views/Settings/Subscription.vue'

import SettingsPersonalization from "../views/Settings/Personalise.vue";


import SettingsFood from "../views/Settings/Food.vue";

import SettingsConditions from "../views/Settings/Conditions.vue";
import SettingsMedications from "../views/Settings/Medications.vue";
import SettingsAddMedication from "../views/Settings/Medicatations/Add.vue";
import SettingsEditMedication from "../views/Settings/Medicatations/Edit.vue";
import SettingsDashboard from "../views/Settings/Dashboard.vue";
import SettingsIntegrations from "../views/Settings/Integrations.vue";
import SettingsPreferences from '../views/Settings/Preferences';
import SettingsActivity from '../views/Settings/Activity.vue';


import IntegrationConfirmation from "../views/IntegrationConfirmation/IntegratedConfirmation"


import Downloads from "../views/Downloads/Downloads.vue";
import DownloadsCategory from "../views/Downloads/DownloadsCategory.vue";

import LifeStyle from "../views/LifeStyle/LifeStyle.vue";
import LifeArticle from "../views/LifeStyle/Article/LifeArticle.vue";
import LifeCategory from "../views/LifeStyle/Category/LifeCategory.vue";
import LifeSearch from "../views/LifeStyle/Search/LifeSearch.vue";
import LifeFavourites from "../views/LifeStyle/Favourites/LifeFavourites.vue";

import Coaching from "../views/Coaching/Coaching.vue";

import Contact from "../views/Contact/Contact.vue";
import NotFound from "../views/404/404.vue";

import Testimonials from "../views/Testimonials/Testimonials.vue";


import HcpLayout from "../views/HealthCareProfessional/Layout.vue"

import HcpArticle from "../views/HealthCareProfessional/Article/Article.vue"
import HcpSearch from "../views/HealthCareProfessional/Search/Search.vue"
import HcpCategory from "../views/HealthCareProfessional/Category/Category.vue"
import HcpCategories from "../views/HealthCareProfessional/Categories/Categories.vue"
import HcpGettingStarted from "../views/HealthCareProfessional/GettingStarted/GettingStarted.vue"


import RecipeIndex from '../views/Recipes/Index.vue'
import RecipeDetail from '../views/Recipes/Detail.vue'
import RecipeCategory from '../views/Recipes/Category.vue'
import RecipeSearch from '../views/Recipes/Search.vue'
import RecipeSearchResults from '../views/Recipes/Results.vue'
import RecipeFavorites from '../views/Recipes/Favorites.vue'
import RecipeMealPlans from '../views/Recipes/MealPlans'

import MealPlanGeneratorIndex from '../views/Recipes/MealPlanGenerator/Index'
import MealPlanDetail from '../views/Recipes/MealPlanDetail'

import FaqIndex from '../views/Faq/Index.vue'
import FaqDetail from '../views/Faq/Detail.vue'

import Callback from "../views/Oauth/Callback";

import $ from "jquery";
import AuthenticationManager from "../helpers/AuthenticationManager";
import Discount from "../views/Discount/Discount";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      name: "404",
      component: NotFound,
      meta: {
        title: "Sign in",
        i18n: "message.fourZeroFourAppBarText",
        hideLeftNav: false,
        requireAuth: false,
        hideLoader: true
      }
    },
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        id: "login",
        title: "Sign in",
        i18n: "message.loginAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: false,
        hideRegisterAppBar: true,
        hideShadow: true
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        id: "register",
        title: "Register",
        i18n: "message.registerAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: false,
        hideShadow: true,
        hideRegisterAppBar: true,
      },
      beforeEnter: (to, from, next) => {
        if (AuthenticationManager.hasToken()) {
          if(AuthenticationManager.parseJwt().scope[0] === 'unsubscribed_tasks') {
            return next({path:'/subscribe'})
          } else {
            next();
          }
        } else {
          next()
        }
      }
    },
    {
      path: "/register/amend",
      name: "AmendRegistration",
      component: Amend,
      meta: {
        id: "register",
        title: "Register",
        i18n: "message.registerAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: true,
        hideShadow: true
      }
    },
    {
      name: "Payment",
      path: "/payment",
      component: Payment,
      meta: {
        id: "Payment",
        title: "Payment",
        i18n: "Payment",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: false
      }
    },
    {
      name: "Subscription",
      path: "/subscribe",
      component: Subscription,
      meta: {
        id: "Subscription",
        title: "Subscription",
        i18n: "Subscription",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: true
      }
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
      meta: {
        id: "forgot-password",
        title: "Forgot Password",
        i18n: "message.forgotPasswordAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: false,
        hideShadow: true,
      }
    },
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: PasswordReset,
      meta: {
        id: "reset-password",
        title: "Reset Password",
        i18n: "message.resetPasswordAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: false,
        hideShadow: true,
        hideRegisterAppBar: true,
      }
    },
    {
      path: '/email-verification',
      name: 'EmailVerification',
      component: EmailVerification,
      meta: {
        id: "verification",
        i18n: "message.verifyAccountAppBarText",
        requireAuth: true
      }
    },
    {
      path: "/getting-started/",
      redirect: "/getting-started/about-you",
      component: GettingStartedLayout,
      meta: {
        id: "getting-started",
        title: "Getting started",
        i18n: "message.obAboutAppBarText",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: true,
        hideShadow: true
      },
      children: [
        {
          path: "/getting-started/about-you",
          name: "GettingStartedAboutYourself",
          component: GettingStartedAboutYourself,
          meta: {
            reuse: false,
            id: "getting-started",
            title: "Getting started",
            i18n: "message.obAboutAppBarText",
            hideLeftNav: true,
            isAuthView: true,
            requireAuth: true,
            hideShadow: true
          }
        },
        {
          path: "/getting-started/your-health",
          name: "GettingStartedYourHealth",
          component: GettingStartedYourHealth,
          meta: {
            reuse: false,
            id: "getting-started",
            title: "Your Health",
            i18n: "message.obHealthAppBarText",
            hideLeftNav: true,
            isAuthView: true,
            requireAuth: true,
          }
        },
        {
          path: "/getting-started/location",
          name: "GettingStartedLocation",
          component: GettingStartedLocation,
          meta: {
            reuse: false,
            id: "getting-started",
            title: "Location",
            i18n: "message.obLocationAppBarText",
            hideLeftNav: true,
            isAuthView: true,
            requireAuth: true,
          }
        },
        {
          path: "/getting-started/goals",
          name: "GettingStartedGoals",
          component: GettingStartedGoals,
          meta: {
            reuse: false,
            id: "getting-started",
            title: "Goals",
            i18n: "message.obGoalsAppBarText",
            hideLeftNav: true,
            isAuthView: true,
            requireAuth: true,
          }
        },
        {
          path: "/getting-started/personalise",
          name: "GettingStartedPersonalise",
          component: GettingStartedPersonalise,
          meta: {
            reuse: false,
            id: "getting-started",
            title: "Personalise",
            i18n: "message.obPersonalizeAppBarText",
            hideLeftNav: true,
            isAuthView: true,
            requireAuth: true,
          }
        }
      ],
      beforeEnter: (to, from, next) => {
        if (AuthenticationManager.hasToken()) {
          if(AuthenticationManager.parseJwt().scope[0] === 'unsubscribed_tasks') {
            return next({path:'/subscribe'})
          } else {
            next();
          }
        } else {
          next()
        }
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        isChild: false,
        id: "dashboard",
        title: "Your dashboard",
        i18n: "message.dashboardAppBarText",
        requireAuth: true
       // paymentWall: true,
      }
    },
    {
      path: "/food-diary",
      name: "FoodDiary",
      component: FoodDiary,
      meta: {
        isChild: true,
        id: "food-diary",
        i18n: "message.foodDiaryAppBarText",
        requireAuth: true
      }
    },
    {
      path: "/food-diary/history",
      name: "FoodDiaryHistory",
      component: FoodDiaryHistory,
      meta: {
        id: "food-diary",
        i18n: 'message.foodDiaryAppBarText',
        requireAuth: true,
        isChild: true
      }
    },
    {
      path: "/food-diary/new-entry",
      name: "FoodDiaryLanding",
      component: FoodDiaryLanding,
      props: true,
      meta: {
        id: "food-diary",
        i18n: "message.foodDiaryAddFoodAppBarText",
        requireAuth: true
      }
    },
    {
      path: "/food-diary/search",
      name: "FoodDiarySearch",
      component: FoodDiarySearch,
      props: true,
      meta: {
        id: "food-diary-search",
        i18n: "message.foodDiaryAddFoodAppBarText",
        requireAuth: true
      }
    },
    {
      path: "/food-diary/results/",
      name: "FoodDiarySearchResults",
      component: FoodDiarySearchResults,
      meta: {
        id: "food-diary-search-results",
        i18n: "message.foodDiaryAddFoodAppBarText",
        requireAuth: true
      }
    },
    {
      path: "/food-diary/add/",
      name: "FoodDiaryAdd",
      component: FoodDiaryAdd,
      props: true,
      meta: {
        id: "food-diary-add",
        i18n: "message.foodDiaryAddFoodAppBarText",
        requireAuth: true
      }
    },
    {
      path: "/food-diary/edit/",
      name: "FoodDiaryEdit",
      component: FoodDiaryEdit,
      props: true,
      meta: {
        id: "food-diary-edit",
        i18n: "message.foodDiaryAppBarText",
        requireAuth: true,
        isChild: true
      }
    },
    {
      path: "/food-diary/my-meals/",
      name: "FoodDiaryMyMeals",
      component: FoodDiaryMyMeals,
      props: true,
      meta: {
        id: "food-diary-my-meals",
        i18n: "message.foodDiaryAppBarText",
        requireAuth: true,
        isChild: true
      }
    },
    {
      path: "/lesson/:permalink",
      name: "Lesson",
      component: Lesson,
      meta: {
        id: "lesson",
        i18n: "message.lessonTitleText",
        hasCustomTitle: true,
        isChild: true,
        requireAuth: true,
        paymentWall: true,
      }
    },
    {
      path: "/lesson/bonus/:id",
      name: "LessonBonus",
      component: LessonBonus,
      meta: {
        id: "lesson",
        i18n: "message.lessonBonusTitleText",
        hasCustomTitle: true,
        isChild: true,
        requireAuth: true,
        paymentWall: true,
      }
    },
    {
      path: "/questions/most_recent/page/1/",
      redirect: "/questions"
    },
    {
      path: "/questions",
      name: "QuestionsIndex",
      component: QuestionsIndex,
      meta: {
        title: "Questions",
        id: "questions-index",
        i18n: "message.questionsAppBarText",
        requireAuth: true,
        paymentWall: true
      }
    },
    {
      path: "/questions/thread/:id",
      name: "QuestionThread",
      component: QuestionThread,
      meta: {
        title: "QuestionThread",
        id: "question-thread",
        i18n: "message.threadTitleText",
        hasCustomTitle: true,
        isChild: true,
        requireAuth: true,
        paymentWall: true
      }
    },
    {
      path: "/questions/create/",
      name: "Ask a question",
      component: QuestionCreate,
      meta: {
        id: "question-create",
        title: "Ask a question",
        isChild: true,
        i18n: "message.questionsAppBarText",
        requireAuth: true,
        paymentWall: true
      }
    },
    {
      path: "/profile/:profileUrl",
      name: "Profile",
      component: Profile,
      meta: {
        id: "profile",
        title: "Profile",
        i18n: "message.profileAppBarText",
        requireAuth: true,
        hasCustomTitle: true
      },
      children: [
        {
          path: "progress",
          name: "ProfileProgress",
          component: ProfileProgress,
          meta: {
            id: "profile",
            title: "Profile",
            i18n: "message.profileAppBarText",
            requireAuth: true,
            isProfilePage: true
          }
        },
        {
          path: "discussion",
          name: "ProfileDiscussion",
          component: ProfileDiscussion,
          meta: {
            id: "profile",
            title: "Profile",
            i18n: "message.profileAppBarText",
            requireAuth: true,
            isProfilePage: true
          }
        },
        {
          path: "gallery",
          name: "ProfileGallery",
          component: ProfileGallery,
          meta: {
            id: "profile",
            title: "Profile",
            i18n: "message.profileAppBarText",
            requireAuth: true,
            isProfilePage: true
          }
        },
        {
          path: "food-diary",
          name: "ProfileFoodDiary",
          component: ProfileFoodDiary,
          meta: {
            id: "profile",
            title: "Profile",
            i18n: "message.profileAppBarText",
            requireAuth: true,
            isProfilePage: true
          }
        },
        {
          path: "followers",
          name: "ProfileFollowers",
          component: ProfileFollowers,
          meta: {
            id: "profile",
            title: "Profile",
            i18n: "message.profileAppBarText",
            requireAuth: true,
            hasCustomTitle: true,
            isProfilePage: true
          },
        },
        {
          path: "following",
          name: "ProfileFollowing",
          component: ProfileFollowing,
          meta: {
            id: "profile",
            title: "Profile",
            i18n: "message.profileAppBarText",
            requireAuth: true,
            hasCustomTitle: true,
            isProfilePage: true
          },
        }
      ]
    },
    {
      path: "/life",
      name: "LifeStyle",
      component: LifeStyle,
      meta: {
        id: "lifestyle",
        title: "Lifestyle",
        i18n: "message.lifestyleAppBarText",
        hideLoader: true,
        paymentWall: true,
        hasTransHeader: true,
      }
    },
    {
      path: "/life/my-favourites",
      name: "LifeStyleFavourites",
      component: LifeFavourites,
      meta: {
        id: "LifeStyleFavourites",
        title: "Lifestyle",
        isChild: true,
        i18n: "message.lifestyleAppBarText",
        hasCustomTitle: true,
        hideLoader: true,
      }
    },
    {
      path: "/life/:permalink",
      name: "LifeStyleArticle",
      component: LifeArticle,
      meta: {

        id: "LifeStyleDetail",
        title: "Lifestyle",
        isChild: true,
        i18n: "message.lifestyleAppBarText",
        hasCustomTitle: true,
        hideLoader: true,
        paymentWall: true,
      }
    },
    {
      path: "/life/category/:slug",
      name: "LifeStyleCategory",
      component: LifeCategory,
      meta: {
        id: "LifeStyleCategory",
        title: "Lifestyle",
        isChild: true,
        i18n: "message.lifestyleAppBarText",
        hasCustomTitle: true,
        hideLoader: true,
        paymentWall: true,
      }
    },
    {
      path: "/life/search/:search",
      name: "LifeStyleSearch",
      component: LifeSearch,
      meta: {
        id: "LifeStyleSearch",
        title: "Lifestyle",
        isChild: true,
        i18n: "message.lifestyleAppBarText",
        hasCustomTitle: true,
        hideLoader: true,
      }
    },
    {
      path: '/check-in',
      name: "CheckIn",
      component: CheckinLayout,
      meta: {
        id: "add-progress",
        title: "Add progress",
        i18n: "message.checkInAppBarText",
        isChild: true,
        noShadow: true,
        requireAuth: true,
        isBlueBg: false
      },
      children: [
        {
          path: 'weight',
          name: "WeightCheckin",
          component: WeightCheckin,
          meta: {
            id: "add-progress",
            title: "Add progress",
            i18n: "message.checkInAppBarText",
            noShadow: true,
            requireAuth: true,
            isBlueBg: false
          }
        },
        {
          path: 'hba1c',
          name: "Hba1cCheckin",
          component: Hba1cCheckin,
          meta: {
            id: "add-progress",
            title: "Add progress",
            i18n: "message.checkInAppBarText",
            noShadow: true,
            requireAuth: true,
            isBlueBg: false
          }
        },
        {
          path: 'goals',
          name: "GoalsCheckin",
          component: GoalsCheckin,
          meta: {
            id: "add-progress",
            title: "Add progress",
            i18n: "message.checkInAppBarText",
            noShadow: true,
            requireAuth: true,
            isBlueBg: false
          }
        }
      ]
    },
    {
      path: "/add-progress",
      name: "AddProgress",
      component: Progress,
      meta: {
        id: "add-progress",
        title: "Add progress",
        i18n: "message.addProgressAppBarText",
        isChild: true,
        noShadow: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/blood-glucose/",
      name: "BloodGlucoseProgress",
      component: BloodGlucose,
      meta: {
        id: "blood-glucose",
        title: "Your blood glucose progress",
        i18n: "message.bloodGlucoseAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/hba1c/",
      name: "HbA1cProgress",
      component: HbA1c,
      meta: {
        id: "blood-glucose",
        title: "Your HbA1c progress",
        i18n: "message.hbA1cAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: '/tracking/activity/',
      name: 'ActivityProgress',
      component: Activity,
      meta: {
        id: 'activity',
        title: 'Your activity progress',
        i18n: 'message.activityAppBarText',
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: '/tracking/activity/fitbit',
      name: 'ActivityProgressFitbit',
      component: ActivityFitbit,
      meta: {
        id: 'activity-fb',
        title: 'Your activity progress',
        i18n: 'message.activityAppBarText',
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/weight/",
      name: "WeightProgress",
      component: Weight,
      meta: {
        id: "weight",
        title: "Your weight progress",
        i18n: "message.weightAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/sleep/",
      name: "SleepProgress",
      component: Sleep,
      meta: {
        id: "sleep",
        title: "Your sleep progress",
        i18n: "message.sleepAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/sleep/history",
      name: "SleepProgress",
      component: SleepWearable,
      meta: {
        id: "sleep",
        title: "Your sleep progress",
        i18n: "message.sleepAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: '/tracking/sleep/deviceHistory',
      name: "SleepDeviceHistory",
      component: SleepDeviceHistory,
      meta: {
        id: "sleep",
        title: "Your sleep progress",
        i18n: "message.sleepAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/blood-pressure/",
      name: "BloodPressureProgress",
      component: BloodPressure,
      meta: {
        id: "blood-pressure",
        title: "Your blood pressure progress",
        i18n: "message.bloodPressureAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/ketones/",
      name: "KetonesProgress",
      component: Ketones,
      meta: {
        id: "ketones",
        title: "Your ketones progress",
        i18n: "message.ketonesAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/insulin/",
      name: "InsulinProgress",
      component: Insulin,
      meta: {
        id: "insulin",
        title: "Your insulin progress",
        i18n: "message.insulinAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/medication",
      name: "MedicationProgress",
      component: Medication,
      meta: {
        id: "medication",
        title: "Your medication progress",
        i18n: "message.medicationAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/mood",
      name: "MoodProgress",
      component: Mood,
      meta: {
        id: "mood",
        title: "Your mood progress",
        i18n: "message.moodAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/tracking/cholesterol",
      name: "CholesterolProgress",
      component: Cholesterol,
      meta: {
        id: "cholesterol",
        title: "Your cholesterol progress",
        i18n: "message.cholesterolAppBarText",
        isChild: true,
        requireAuth: true
      }
    },
    {
      path: "/settings",
      redirect: "/settings/general",
      component: Settings,
      meta: {
        id: "settings",
        title: "Your settings",
        i18n: "message.settingsAppBarText",
        isChild: true,
        requireAuth: true
      },
      children: [
        {
          name: "SettingsPreferences",
          path: "preferences",
          component: SettingsPreferences,
          meta: {
            id: "settings-preferences",
            title: "General account settings",
            i18n: "message.settingsPreferencesTitleText",
            isChild: false,
            requireAuth: true
          },
        },
        {
          // UserProfile will be rendered inside User"s <router-view>
          // when /user/:id/profile is matched
          name: "SettingsGeneral",
          path: "general",
          component: SettingsGeneral,
          meta: {
            id: "settings-general",
            title: "General account settings",
            i18n: "message.settingsGeneralTitleText",
            isChild: false,
            requireAuth: true
          },
        },
        {
          name: "SettingsSecurity",
          path: "security",
          component: SettingsSecurity,
          meta: {
            id: "settings-security",
            title: "Security settings",
            i18n: "message.settingsSecurityTitleText",
            isChild: false,
            requireAuth: true
          }
        },
        {
          name: "SettingsSubscription",
          path: "subscription",
          component: SettingsSubscription,
          meta: {
            id: "settings-subscription",
            title: "Subscription settings",
            i18n: "message.settingsSubscriptionTitleText",
            isChild: false,
            requireAuth: true
          }
        },
        {
          name: "SettingsPrivacy",
          path: "Privacy",
          component: SettingsPrivacy,
          meta: {
            id: "settings-privacy",
            title: "Privacy settings",
            i18n: "message.settingsPrivacyTitleText",
            isChild: false,
            requireAuth: true
          }
        },
        {
          name: "SettingsNotifications",
          path: "notifications",
          component: SettingsNotifications,
          meta: {
            id: "settings-notifications",
            title: "Notifications settings",
            i18n: "message.settingsNotificationsTitleText",
            isChild: false,
            requireAuth: true
          }
        },
        {
          name: "SettingsUnits",
          path: "units",
          component: SettingsUnits,
          meta: {
            id: "settings-units",
            title: "Unit settings",
            i18n: "message.settingsUnitsTitleText",
            isChild: false,
            requireAuth: true
          }
        },
        {
          name: "SettingsPersonalization",
          path: "personalise",
          component: SettingsPersonalization,
          meta: {
            id: "settings-personalize",
            title: "Personalise",
            i18n: "message.settingsPersonalizeTitleText",
            isChild: false,
            requireAuth: true
          }
        },
        {
          name: "SettingsFood",
          path: "food",
          component: SettingsFood,
          meta: {
            id: "settings-conditions",
            title: "Conditions",
            i18n: "message.settingsFoodTitleText",
            isChild: false,
            requireAuth: true
          }
        },
        {
          name: "SettingsConditions",
          path: "conditions",
          component: SettingsConditions,
          meta: {
            id: "settings-conditions",
            title: "Conditions",
            i18n: "message.settingsConditionsTitleText",
            isChild: false,
            requireAuth: true
          },
        },
        {
          name: "SettingsMedication",
          path: "medications",
          component: SettingsMedications,
          meta: {
            id: "settings-medication",
            title: "Medication",
            i18n: "message.settingsMedicationTitleText",
            isChild: false,
            requireAuth: true
          },
          children: [
            {
              name: "SettingsAddMedications",
              path: "add",
              component: SettingsAddMedication,
              meta: {
                id: "settings-medication",
                title: "Set up a new medication",
                i18n: "message.settingsMedicationTitleText",
                isChild: false,
                requireAuth: true
              }
            },
            {
              name: "SettingsEditMedications",
              path: "edit",
              component: SettingsEditMedication,
              props: true,
              meta: {
                id: "settings-medication",
                title: "Editing medication",
                i18n: "message.settingsMedicationTitleText",
                isChild: false,
                requireAuth: true
              }
            }
          ]
        },
        {
          name: "SettingsDashboard",
          path: "dashboard",
          component: SettingsDashboard,
          meta: {
            id: "settings-dashboard",
            title: "Dashboard",
            i18n: "message.settingsDashboardTitleText",
            isChild: false,
            requireAuth: true
          }
        },
        {
          name: "SettingsIntegrations",
          path: "integrations",
          component: SettingsIntegrations,
          meta: {
            id: "settings-integrations",
            title: "Integrations",
            i18n: "message.settingsIntegrationTitleText",
            isChild: false,
            requireAuth: true
          }
        },
        {
          name: "SettingsActivity",
          path: "activity",
          component: SettingsActivity,
          meta: {
            title: "Activity",
            i18n: "message.settingsActivityTitleText",
            isChild: false,
            requireAuth: true
          }
        },
      ]
    },
    {
      name: "Downloads",
      path: "/downloads",
      component: Downloads,
      meta: {
        id: "downloads",
        title: "Downloads",
        i18n: "message.downloadsAppBarText",
        requireAuth: true,
        paymentWall: true,
      },
    },
    {
      name: "DownloadsCategory",
      path: "/downloads/category/:slug",
      component: DownloadsCategory,
      meta: {
        id: "downloads",
        title: "Downloads",
        i18n: "message.downloadsAppBarText",
        requireAuth: true,
        paymentWall: false,
      },
    },
    {
      name: "Coaching",
      path: "/coaching",
      component: Coaching,
      meta: {
        id: "coaching",
        title: "Coaching",
        i18n: "message.coachingAppBarText",
        requireAuth: true
      }
    },
    {
      name: "AnswerReport",
      path: '/reports/answer/:id',
      component: AnswerReport,
      meta: {
        id: "answer-reporting",
        title: "Answer reporting",
        isChild: true,
        i18n: "message.answerReportAppBarText",
        hasCustomTitle: true,
        requireAuth: true
      }
    },
    {
      name: 'QuestionReport',
      path: '/reports/question/:id',
      component: QuestionReport,
      meta: {
        id: "answer-reporting",
        title: "Answer reporting",
        isChild: true,
        i18n: "message.questionReportAppBarText",
        hasCustomTitle: true,
        requireAuth: true
      }
    },
    {
      name: 'LifeReplyReport',
      path: '/reports/life/reply/:id',
      component: LifeReplyReport,
      meta: {
        id: "life-reporting",
        title: "Life comment reporting",
        isChild: true,
        i18n: "message.lifeReportAppBarText",
        hasCustomTitle: true,
        requireAuth: true
      }
    },
    {
      name: 'LifeSubReplyReport',
      path: '/reports/life/subreply/:id',
      component: LifeSubReplyReport,
      meta: {
        id: "life-reporting",
        title: "Life comment reporting",
        isChild: true,
        i18n: "message.lifeReportAppBarText",
        hasCustomTitle: true,
        requireAuth: true
      }
    },
    {
      name: "Contact",
      path: "/contact",
      component: Contact,
      meta: {
        id: "contact",
        title: "Contact us",
        i18n: "message.contactAppBarText",
        requireAuth: true
      }
    },
    {
      name: "Testimonials",
      path: "/testimonials",
      component: Testimonials,
      meta: {
        id: "testimonials",
        title: "Testimonials",
        i18n: "message.testimonialAppBarText",
        requireAuth: true
      }
    },
    {
      name: "Integrated",
      path: "/integrated",
      component: IntegrationConfirmation,
      meta: {
        id: "integration",
        title: "Integration complete",
        i18n: "message.integrationCompleteAppBarText",
        requireAuth: true
      }
    },
    {
      name: 'HealthCareProfessional',
      path: '/hcp',
      redirect: '/hcp/categories',
      component: HcpLayout,
      meta: {
        id: 'hcp',
        title: 'Health Care Professional',
        i18n: 'message.hcpAppBarText',
        requireAuth: true,
        requireHcpVerification: true
      },
      children: [
        {
          path: "/hcp/getting-started",
          name: "HcpGettingStarted",
          component: HcpGettingStarted,
          meta: {
            reuse: false,
            id: "hcp",
            title: "Getting started",
            i18n: "message.hcpAppBarText",
            hideLeftNav: true,
            isAuthView: true,
            requireAuth: true,
            hideShadow: true
          }
        },
        {
          path: "/hcp/categories",
          name: "HcpCategories",
          component: HcpCategories,
          meta: {
            id: "hcpCategory",
            title: "Health Care Professionals",
            i18n: "Education",
            requireAuth: true,
            requireHcpVerification: true
          }
        },
        {
          path: "/hcp/category/:slug",
          name: 'HcpCategory',
          component: HcpCategory,
          meta: {
            id: "hcpCategory",
            isChild: true,
            title: "Health Care Professionals",
            i18n: "Education",
            requireAuth: true,
            hasCustomTitle: true,
            requireHcpVerification: true
          }
        },
        {
          path: "/hcp/article/:slug",
          name: 'HcpArticle',
          component: HcpArticle,
          meta: {
            id: "hcpArticle",
            isChild: true,
            title: "Health Care Professionals",
            i18n: "message.hcpAppBarText",
            requireAuth: true,
            hasCustomTitle: true,
            requireHcpVerification: true
          }
        },
        {
          path: "/hcp/search/:search",
          name: 'HcpSearch',
          component: HcpSearch,
          meta: {
            id: "hcpSearch",
            isChild: true,
            title: "Health Care Professionals",
            i18n: "message.hcpAppBarText",
            requireAuth: true,
            hasCustomTitle: true,
            requireHcpVerification: true
          }
        }
      ]
    },
    {
      name: 'Faq',
      path: '/faq',
      component: FaqIndex,
      meta: {
        id: 'faq',
        title: 'Frequently asked questions',
        i18n: 'message.faqAppBarText',
        requireAuth: true,
        isBlueBg: true
      },
      children: [
        {
          name: 'FaqDetail',
          path: ':id',
          component: FaqDetail,
          meta: {
            id: 'faq',
            title: 'Frequently asked questions',
            i18n: 'message.faqAppBarText',
            requireAuth: true,
            isChild: true
          }
        }
      ]
    },
    {
      path: "/recipes",
      name: "RecipeIndex",
      component: RecipeIndex,
      meta: {
        id: "recipes",
        title: "Recipes",
        i18n: "message.recipesAppBarText",
        isChild: true,
        requireAuth: true,
        paymentWall: true,
        hasTransHeader: true
      }
    },
    {
      path: '/recipes/mealplans',
      name: 'RecipeMealPlans',
      component: RecipeMealPlans,
      meta: {
        id: "recipe-meal-plans",
        title: "Recipes",
        i18n: "message.recipesAppBarText",
        isChild: true,
        requireAuth: true,
        paymentWall: true,
        hasTransHeader: false
      }
    },
    {
      path: '/recipes/mealplans/:id',
      name: 'MealPlanDetail',
      component: MealPlanDetail,
      meta: {
        id: "recipe-meal-plans",
        title: "Recipes",
        i18n: "message.recipesAppBarText",
        isChild: true,
        requireAuth: true,
        paymentWall: true,
        hasTransHeader: false
      }
    },
    {
      path: '/recipes/bygroup/',
      name: 'RecipeCategory',
      component: RecipeCategory,
      meta: {
        id: 'recipe-dietary-types',
        title: 'Recipes',
        i18n: "message.recipesAppBarText",
        isChild: true,
        requireAuth: true,
        paymentWall: true,
        hasTransHeader: false
      }
    },
    {
      path: '/recipes/favorites',
      name: 'RecipeFavorites',
      component: RecipeFavorites,
      meta: {
        id: 'recipes-search',
        title: "Recipes",
        i18n: "message.recipesFavoritesAppBarText",
        requireAuth: true,
        paymentWall: true,
        isChild: true
      }
    },
    {
      path: '/recipes/search',
      name: 'RecipeSearch',
      component: RecipeSearch,
      meta: {
        id: 'recipes-search',
        title: "Recipes",
        i18n: "message.recipesAdvancedSearchAppBarText",
        requireAuth: true,
        paymentWall: true,
        isChild: true
      }
    },
    {
      path: '/recipes/generator/',
      name: 'RecipeMealPlanGenerator',
      component: MealPlanGeneratorIndex,
      meta: {
        id: 'recipes-meal-plan-generator',
        title: "Recipes",
        i18n: "message.mealPlanGeneratorAppBarText",
        requireAuth: true,
        paymentWall: true,
        isChild: true,
        hasTransHeader: false
      }
    },
    {
      path: '/recipes/results',
      name: 'RecipeSearchResults',
      component: RecipeSearchResults,
      props: true,
      meta: {
        id: 'recipes-search',
        title: "Recipes",
        i18n: "message.recipesAdvancedSearchAppBarText",
        requireAuth: true,
        paymentWall: true,
        isChild: true
      }
    },
    {
      path: '/recipes/:id',
      name: 'RecipeDetail',
      component: RecipeDetail,
      meta: {
        id: 'recipes-detail',
        title: "Recipes",
        i18n: "message.recipeAppBarText",
        hasCustomTitle: true,
        requireAuth: true,
        paymentWall: true,
        isChild: true
      }
    },
    {
      path: '/oauth/callback',
      name: 'OauthCallback',
      component: Callback,
      meta: {
        id: 'oauth-callback',
        title: "callback",
        hasCustomTitle: false,
        requireAuth: false,
        paymentWall: false,
        isChild: false
      }
    },
    {
      path: '/discount-page',
      name: 'Discount',
      component: Discount,
      meta: {
        id: "discount",
        title: "Discount",
        i18n: "Discount",
        hideLeftNav: true,
        isAuthView: true,
        requireAuth: false,
        hideRegisterAppBar: true,
        hideShadow: true
      }
    }

  ],
  scrollBehavior(to, from) {
    $("#" + to.meta.id).scrollTop(0);
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js